/**
 * The video editor's address (v1.0.29), stated once: `features/cabinet/routes.ts` hands it to the
 * router, and the article list links each video to it. A video is reached from the list's Videos
 * tab, so going back lands there (`VIDEOS_HREF`, which the list reads as its opening tab).
 */
export const VIDEO_EDITOR_ROUTE_PATH = '/videos/$articleId/edit';

export function videoEditorHrefFor(articleId: string): string {
  return `/videos/${encodeURIComponent(articleId)}/edit`;
}

/** The query the article list opens on its Videos tab with. */
export const VIDEOS_TAB_QUERY = 'show=videos';

export const VIDEOS_HREF = `/articles?${VIDEOS_TAB_QUERY}`;
